import { z } from 'zod'

/** Permissões granulares do sistema. A API e o web usam esta lista como única fonte. */
export const PERMISSIONS = [
  'cases.read',
  /** Ver a carteira inteira. Sem ela, toda consulta de casos fica restrita à cobradora do usuário. */
  'cases.read_all',
  'cases.write',
  'cases.reassign',
  'cases.export',
  'customers.read',
  'customers.write',
  /** Mesclar cadastros duplicados, descartar grupos e reverter mesclagens (sprint-5-spec §1). */
  'customers.merge',
  'agreements.write',
  /** Aprovar ou recusar proposta de acordo com desconto acima do limite de quem criou. */
  'agreements.approve',
  'payments.write',
  'campaigns.manage',
  /** Criar, editar, versionar e ativar templates de mensagem (sprint-6-spec §1). */
  'templates.manage',
  'reminders.manage',
  'reports.view',
  'reports.build',
  /** Ver o financeiro (Sprint 11): lançamentos, fluxo de caixa, DRE e conciliação. */
  'finance.read',
  /** Lançar, baixar, estornar, conciliar e anexar no financeiro. */
  'finance.write',
  /** Contas bancárias, categorias, centros de custo, mapeamento do ERP e fechamento de mês. */
  'finance.manage',
  'imports.run',
  'admin.users',
  /** Perfis e matriz de permissões (sprint-13-spec §0; só diretoria no seed). */
  'admin.roles',
  /** Cobradoras e unidades (sprint-13-spec §0; coordenação e diretoria no seed). */
  'admin.collectors',
  'admin.settings',
  'admin.audit',
  /** Exportação e anonimização de titular, retenção, consentimento em lote (sprint-13-spec §0). */
  'lgpd.manage',
  /** CRM de vendas (sprint-17-spec §1): ver os próprios leads e o funil. */
  'sales.read',
  /** Ver os leads de todos os vendedores, a exportação e as métricas da equipe. */
  'sales.read_all',
  /** Criar e editar leads, mover no funil, registrar contato, ganhar, perder e reabrir. */
  'sales.write',
  /** Funil, etapas, motivos de perda, reatribuição e importação de leads. */
  'sales.manage',
] as const

export type Permission = (typeof PERMISSIONS)[number]

export const PermissionSchema = z.enum(PERMISSIONS, { error: 'Permissão desconhecida.' })

export function isPermission(value: string): value is Permission {
  return (PERMISSIONS as readonly string[]).includes(value)
}

/** Verdadeiro quando `granted` contém todas as permissões exigidas. */
export function hasPermissions(
  granted: readonly Permission[],
  ...required: readonly Permission[]
): boolean {
  return required.every((permission) => granted.includes(permission))
}
